import { forwardRef, type HTMLAttributes, type ReactNode } from 'react';
import { cn } from '../lib/cn.js';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** Coloured left rule used by attention and risk cards. */
  accentClassName?: string;
  interactive?: boolean;
}

/** White surface, 1px border, 12px radius — the container of almost every block. */
export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  { accentClassName, interactive, className, children, ...rest },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cn(
        'rounded-xl border border-line bg-surface',
        accentClassName && `border-l-[3px] ${accentClassName}`,
        interactive &&
          'cursor-pointer transition-colors hover:border-primary-border hover:bg-[#FCFDFF]',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
});

export interface CardSectionProps {
  children: ReactNode;
  className?: string;
}

export function CardBody({ children, className }: CardSectionProps) {
  return <div className={cn('p-[18px]', className)}>{children}</div>;
}

export function CardHeader({ children, className }: CardSectionProps) {
  return (
    <div
      className={cn('flex items-start justify-between gap-3 px-[18px] pb-3 pt-[18px]', className)}
    >
      {children}
    </div>
  );
}

export function CardDivider({ className }: { className?: string }) {
  return <div className={cn('h-px w-full bg-line-subtle', className)} />;
}
